import type { VPAuthConfig } from '@vp/ubik-context'

const isDevelopmentMode = (): boolean => {
  if (typeof window === 'undefined') return false
  const hostname = window.location?.hostname ?? ''
  return hostname.includes('staging.') || hostname === 'localhost'
}

export const createAuthConfig = (culture: string): VPAuthConfig => ({
  culture,
  developmentMode: isDevelopmentMode(),
  options: {
    requireSession: true,
    customText: 'Sign in to see your account',
    clientID: process.env?.['COAM_CLIENT_ID'] || process.env?.['AUTH_CLIENT_ID'],
  },
})
